'use strict';
import { fixedPrice } from '../../utils/formater';
import {RENT, SALE, APARTMENTS, RENTDAILY} from '../../consts';
/**
 * Цена
 * @constructor
 * @param value
 */
function Price (value) {
  this.value = isNaN(parseFloat(value)) ? 0.0 : parseFloat(value);
}

Price.PER_SQUARE_METER = 'м²';  /** За квадратный метр */
Price.PER_AR = 'сот.';          /** За сотку */
Price.PER_MONTH = 'мес.';      /** За месяц */
Price.PER_DAY = 'сутки';         /** За день */

Price.prototype.getValue = function () {
  return this.value;
};

/**
 * Фиксированная или нет
 * @returns {boolean}
 */
Price.prototype.isFixed = function () {
  return this.getValue() === 0;
};

/**
 * Выводить лайбел с рублями и измерением
 * @param per
 * @param devider
 * @returns {string}
 */
Price.prototype.getLabel = function (per = null, devider = '/') {
  if (this.getValue() === 0) {
    return 'договорная';
  }

  return fixedPrice(this.getValue(), per, devider);
};

/**
 * Возвращает отклонение в процентах
 * @param percent
 * @returns {{priceMin: number, priceMax: *}}
 */
Price.prototype.getPercentDeviation = function (percent) {
  const price = this.getValue();
  const rate = price * (percent / 100);

  return {
    priceMin: price - rate,
    priceMax: price + rate
  };
};

/**
 * Информация о цене
 * @param item
 * @returns {{price: string, perAre: *, perSquareMeter: *, utilities, commission: null, addition: null}}
 */
Price.getPriceInfo = function (item) {
  const dealType = item.getDealType();
  const pricePerAre = item.getPricePerAre();
  const pricePerSquareMeter = item.getPricePerSquareMeter();

  const dealCondition = item.getDealCondition();
  const commission = dealCondition.getCommissionRealtor();

  const pricePer = dealType === RENT ? Price.PER_MONTH : (dealType === RENTDAILY ? Price.PER_DAY : null);

  const info = {
    priceValue: item.getPrice().getValue(),
    price: item.getPrice().getLabel(),
    pricePer: item.getPrice().getLabel(pricePer),
    perAre: pricePerAre ? pricePerAre.getLabel(Price.PER_AR) : null,
    perAreValue: pricePerAre ? pricePerAre.getValue() : null,
    perSquareMeter: pricePerSquareMeter ? pricePerSquareMeter.getLabel(Price.PER_SQUARE_METER) : null,
    perSquareMeterValue: pricePerSquareMeter ? pricePerSquareMeter.getValue() : null,
    utilities: dealCondition.getLabelUtilitiesPrice(),
    commission: null,
    deposit: dealCondition.getLabelDeposit(),
    addition: null
  };

  if (commission) {
    if (dealType === SALE) {
      info.commission = commission.getLabel();
    } else {
      info.commission = !commission.isRequired() ? 'коммисия\u00A0-\u00A00\u00A0₽' : null;
    }
  }

  // не показывать гектары если надо только квадраты
  if (item.getAreaPriceType() === Price.PER_SQUARE_METER) {
    info.perAre = null;
    info.addition = info.perSquareMeter;
  } else {
    info.perSquareMeter = null;
    info.addition = info.perAre;
  }

  // если аренда квартир
  if (dealType === RENT && item.getRealtyType() === APARTMENTS) {
    const priceAddition = [];

    if (info.utilities) {
      priceAddition.push(info.utilities);
    }

    if (info.deposit) {
      priceAddition.push('+\xa0' + info.deposit);
    }

    if (info.commission) {
      priceAddition.push(info.commission);
    }

    info.addition = priceAddition.join(', ');
  }

  return info;
};

export default Price;



// WEBPACK FOOTER //
// ./src/classes/finance/price.js